export default __webpack_public_path__ + "static/media/video8.401ac629.mp4";